module.exports = __webpack_public_path__ + "static/images/banner.39c06fb.jpg";